import {
  Col,
  Row,
  Modal,
  Button,
  Flex,
  Select,
  Image,
  Card,
  Divider,
  message,
} from "antd";
import { useEffect, useState } from "react";
import img2 from "../../../../accset/category/image2.png";
import { Link } from "react-router-dom";
import { Flower } from "../../../@type/flowerType";
import { dispatch, useSelector } from "../../../redux/store";
import { getFlower } from "../../../redux/action/flower";
import { updateFlowerPackage } from "../../../redux/action/flower-package";


interface Props {
  flower: Flower[];
  packageId:number
}

export default function PackageItem({ flower, packageId }: Props) {
  const [open, setOpen] = useState(false);
  const [selectedFlower, setSelectedFlower] = useState<Flower | null>(null);
  const [selectedFlowerId, setSelectedFlowerId] = useState<number | null>(null);

  const { flowerList } = useSelector((state) => state.flower);
    
  // Load toàn bộ hoa
  useEffect(() => {
    (async () => {
      await dispatch(getFlower());
    })();
  }, []);

  // Khi bấm Thay đổi
  const handleDetail = (flower: Flower, flowerId?: number) => {
    setSelectedFlower(flower);
    setOpen(true);
    setSelectedFlowerId(flowerId || null);
  }
const handleConfirm = async () => {
  if (!selectedFlower || !selectedFlowerId) return;

  try {
    await dispatch(
      updateFlowerPackage({
        packageId: packageId,
        oldFlowerId: Number(selectedFlowerId),
        newFlowerId: Number(selectedFlower.flowerId),
      })
    );

    message.success("Thay đổi hoa thành công!"); // thông báo thành công
    setOpen(false);
  } catch (error) {
    console.error(error);
    message.error("Thay đổi hoa thất bại. Vui lòng thử lại!"); // thông báo lỗi
  }
};

  return (
    <div>
      <Row gutter={[24, 24]}>
        {flower.length < 4 && flower.map((flower) => (
          <Col key={flower.flowerId} xl={8} lg={8} md={12} sm={24} xs={24}>
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                transition: "all 0.3s",
              }}
            >
              <Link to={`/Product/${flower.flowerId}`}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "100%",
                    backgroundColor: "#fdeef0",
                  }}
                >
                  <img
                    src={flower.images?.[0]?.imageUrl || img2}
                    alt={flower.name}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </Link>

              <Flex justify="space-between" style={{ padding: "12px 16px" }}>
                <div>
                  <p style={{ fontSize: 13, color: "#666", margin: 0 }}>
                    Vòng đời: {flower.lifespan}
                  </p>

                  <h2
                    style={{
                      fontWeight: 700,
                      fontSize: 16,
                      marginBlock: 8,
                    }}
                  >
                    {flower.name}
                  </h2>

                  <p style={{ fontSize: 13, color: "#666" }}>{flower.origin}</p>
                </div>

                <Button type="primary" onClick={() => handleDetail(flower, flower.flowerId)}>
                  Thay đổi
                </Button>
              </Flex>
            </div>
          </Col>
        ))}
         {flower.length >= 4 && flower.map((flower) => (
          <Col key={flower.flowerId} xl={6} lg={8} md={12} sm={24} xs={24}>
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                transition: "all 0.3s",
              }}
            >
              <Link to={`/Product/${flower.flowerId}`}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "100%",
                    backgroundColor: "#fdeef0",
                  }}
                >
                  <img
                    src={flower.images?.[0]?.imageUrl || img2}
                    alt={flower.name}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </Link>

              <Flex justify="space-between" style={{ padding: "12px 16px" }}>
                <div>
                  <p style={{ fontSize: 13, color: "#666", margin: 0 }}>
                    Vòng đời: {flower.lifespan}
                  </p>

                  <h2
                    style={{
                      fontWeight: 700,
                      fontSize: 16,
                      marginBlock: 8,
                    }}
                  >
                    {flower.name}
                  </h2>

                  <p style={{ fontSize: 13, color: "#666" }}>{flower.origin}</p>
                </div>

                <Button type="primary" onClick={() => handleDetail(flower, flower.flowerId)}>
                  Thay đổi
                </Button>
              </Flex>
            </div>
          </Col>
        ))}
      </Row>

      {/* MODAL */}
      <Modal
        open={open}
        title="Chọn hoa thay thế"
        onCancel={() => setOpen(false)}
        footer={null}
      >
       <Select
  style={{ width: "100%", marginBottom: 16, height: 46 }}
  placeholder="Chọn hoa"
  value={selectedFlower?.flowerId}
  onChange={(id) => {
    const f = flowerList.find((i: Flower) => i.flowerId === id);
    setSelectedFlower(f || null);
  }}
  options={flowerList.map((item: Flower) => ({
    label: item.name,
    value: item.flowerId,
    disabled: flower.some((f) => f.flowerId === item.flowerId), 
  }))}
/>


        {selectedFlower && (
          <Flex vertical gap={16}>
            <Card
              style={{
                borderRadius: 16,
                background: "#ffffff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.07)",
              }}
            >
              <Flex gap={20}>
                <Image
                  src={selectedFlower.images?.[0]?.imageUrl || img2}
                  style={{
                    width: 110,
                    height: 110,
                    borderRadius: 12,
                    objectFit: "cover",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  }}
                  preview={false}
                />

                <div style={{ flex: 1 }}>
                  <p style={{ margin: 0, fontWeight: 600 }}>
                    {selectedFlower.name}
                  </p>

                  <p style={{ margin: "6px 0 0", color: "#444" }}>
                    <strong style={{ color: "#333" }}>Vòng đời:</strong>{" "}
                    {selectedFlower.lifespan}
                  </p>

                  <p style={{ margin: "4px 0 0", color: "#444" }}>
                    <strong style={{ color: "#333" }}>Nguồn gốc:</strong>{" "}
                    {selectedFlower.origin}
                  </p>
                </div>
              </Flex>

              <Divider />

              <p
                style={{
                  lineHeight: 1.6,
                  marginTop: 8,
                  color: "#555",
                }}
              >
                <strong style={{ color: "#333" }}>Mô tả:</strong>{" "}
                {selectedFlower.description}
              </p>
            </Card>
            <Card
              style={{
                borderRadius: 16,
                background: "#ffffff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.07)",
              }}
            >
              <Flex justify="flex-end" gap={8}>
                <Button onClick={() => setOpen(false)}>Huỷ bỏ</Button>

                <Button type="primary" onClick={handleConfirm}>
                  Xác nhận
                </Button>
              </Flex>
            </Card>
          </Flex>
        )}
      </Modal>
    </div>
  );
}
